export default "__VITE_ASSET__516f9c7f__"